export default function SelectionErrorHandler(errorInput, id = "") {
  const separator = " ";
  const defaultError = "Произошла непредвиденная ошибка";

  // Если передан объект violations - объединяем все значения полей
  if (
    typeof errorInput === "object" &&
    errorInput !== null &&
    !Array.isArray(errorInput)
  ) {
    const messages = Object.values(errorInput)
      .filter((value) => typeof value === "string" && value.trim() !== "")
      .map((msg) => (msg.endsWith(".") ? msg : msg + "."));

    if (messages.length > 0) {
      const result = messages.join(separator);
      return id !== "" ? `${result}\nID запроса: ${id}` : result;
    }
    return id !== "" ? `${defaultError}\nID запроса: ${id}` : defaultError;
  }

  // Если передана строка (поле error)
  if (
    typeof errorInput === "string" &&
    !errorInput.trim().startsWith("[") &&
    !errorInput.trim().startsWith("{")
  ) {
    const errorMessage = errorInput.endsWith(".")
      ? errorInput
      : errorInput + ".";
    return id !== "" ? `${errorMessage}\nID запроса: ${id}` : errorMessage;
  }

  try {
    const parsedErrors = JSON.parse(errorInput);

    if (Array.isArray(parsedErrors)) {
      if (id !== "") parsedErrors.push({ message: `ID запроса: ${id}` });

      return parsedErrors
        .filter((item) => item?.message)
        .map((item) => {
          const msg = item.message;
          if (msg.startsWith("ID запроса:")) return `\n${msg}`;
          return msg.endsWith(".") ? msg : msg + ".";
        })
        .join(separator);
    }
  } catch (e) {
    // console.error(e);
    return id !== "" ? `${defaultError}\nID запроса: ${id}` : defaultError;
  }
}

